export const FileLink = "https://backend.hnam3ak.ma/public/assets/images/";
export const ApiUrl = "https://backend.hnam3ak.ma/api/";
export const FileLinkImg = "https://hnam3ak.ma/assets/img/";
export const FileLinkAssets="https://hnam3ak.ma/assets/";


// export const ApiUrl = "http://localhost:8000/api/";
// export const FileLink = "http://localhost:8000/assets/images/";
// export const FileLinkImg = "http://localhost:3000/assets/img/";
// export const FileLinkAssets="http://localhost:3000/assets/img/";
